import React, { useState } from 'react';
import { ArrowRight, Menu, Phone, X } from 'lucide-react';
import { company } from '../data/company';
const links = [{
  label: 'Services',
  href: '#services'
}, {
  label: 'Work',
  href: '#gallery'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'Coverage',
  href: '#areas'
}, {
  label: 'Contact',
  href: '#quote'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full border-b border-ink-line bg-ink/95 backdrop-blur" data-id="element-57" data-mp="2rldxreimsp3i">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-5 px-6 py-3" data-id="element-58" data-mp="2wjxkvi8yo6xg">
        <a href="#top" className="shrink-0" data-id="element-59" data-mp="31d06933l4a2k">
          <img src={company.logo} alt={company.legalName} className="h-10 w-auto" data-id="element-60" data-mp="31eb990p7hdsm" />
        </a>

        <div className="hidden items-center gap-5 md:flex lg:gap-8" data-id="element-61" data-mp="3baxuvrpcw8vp">
          <nav aria-label="Main" className="flex items-center gap-5 lg:gap-8" data-id="element-62" data-mp="3fbq4im254fsi">
            {links.map(link => <a key={link.href} href={link.href} className="font-mono text-[11px] uppercase tracking-[0.18em] text-white/70 transition-colors hover:text-gold" data-id="element-63" data-mp="2wldw5nefh198">
                {link.label}
              </a>)}
          </nav>

          <a href="#quote" className="inline-flex shrink-0 items-center gap-2 bg-gold px-5 py-2.5 text-sm font-bold uppercase tracking-[0.06em] text-ink transition-colors hover:bg-gold-dark" data-id="element-64" data-mp="2ho3kacxvhtcz">
            Free estimate
            <ArrowRight className="h-4 w-4" aria-hidden="true" data-id="element-65" data-mp="3aec74i3ct1xw" />
          </a>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} className="inline-flex h-10 w-10 shrink-0 items-center justify-center border border-white/25 text-white md:hidden" data-id="element-66" data-mp="35jpwih53jdev">
          {open ? <X className="h-5 w-5" data-id="element-67" data-mp="3t9af2yxc88nm" /> : <Menu className="h-5 w-5" data-id="element-68" data-mp="1rd1jgtpy4hib" />}
        </button>
      </div>

      {open && <nav aria-label="Mobile" className="border-t border-ink-line bg-ink px-6 pb-5 md:hidden" data-id="element-69" data-mp="1wco5nsnr5839">
          {links.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="block border-b border-white/10 py-3 font-mono text-xs uppercase tracking-[0.18em] text-white/80" data-id="element-70" data-mp="1hni07mybmlmx">
              {link.label}
            </a>)}
          <a href="#quote" onClick={() => setOpen(false)} className="mt-4 inline-flex items-center gap-2 bg-gold px-5 py-3 text-sm font-bold uppercase tracking-[0.06em] text-ink" data-id="element-71" data-mp="1cmkjzfwvg1o2">
            Free estimate
            <ArrowRight className="h-4 w-4" aria-hidden="true" data-id="element-72" data-mp="2t3yjjrczxmf2" />
          </a>
          <a href={company.phoneHref} className="mt-4 flex items-center gap-2 text-sm font-semibold text-gold" data-id="element-73" data-mp="2y1rropxv0qhz">
            <Phone className="h-4 w-4" aria-hidden="true" data-id="element-74" data-mp="mf6duz64li9p" />
            {company.phone}
          </a>
        </nav>}
    </header>;
}